// import React, { useState, useRef, useEffect } from 'react';
// import './App.css';

// function App() {
//   const [url, setUrl] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [mediaInfo, setMediaInfo] = useState(null);
//   const [selectedQuality, setSelectedQuality] = useState('highest');
//   const [downloadProgress, setDownloadProgress] = useState({});
//   const [previewUrl, setPreviewUrl] = useState('');
//   const videoRef = useRef(null);

//   const API_URL = 'https://api.banksstatements.com';

//   // Clean up preview URL when component unmounts
//   useEffect(() => {
//     return () => {
//       if (previewUrl) {
//         URL.revokeObjectURL(previewUrl);
//       }
//     };
//   }, [previewUrl]);

//   const downloadMedia = async (mediaUrl, filename, id) => {
//     try {
//       setDownloadProgress(prev => ({ ...prev, [id]: 0 }));
      
//       const response = await fetch(`${API_URL}/download`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           url: mediaUrl, 
//           quality: selectedQuality
//         })
//       });

//       if (!response.ok) {
//         throw new Error('Download failed');
//       }

//       const data = await response.json();
      
//       if (data.downloadId) {
//         // Poll for download progress
//         const progressInterval = setInterval(async () => {
//           const progressResponse = await fetch(`${API_URL}/progress/${data.downloadId}`);
//           if (!progressResponse.ok) {
//             clearInterval(progressInterval);
//             throw new Error('Failed to get progress');
//           }
          
//           const progressData = await progressResponse.json();
          
//           if (progressData.status === 'completed') {
//             clearInterval(progressInterval);
//             setDownloadProgress(prev => ({ ...prev, [id]: 100 }));
            
//             // Download the file
//             window.location.href = `${API_URL}/file?path=${encodeURIComponent(progressData.filePath)}`;
//           } else if (progressData.status === 'error') {
//             clearInterval(progressInterval);
//             throw new Error(progressData.error || 'Download failed');
//           } else {
//             setDownloadProgress(prev => ({ ...prev, [id]: progressData.progress }));
//           }
//         }, 1000);
//       } else if (data.files && data.files.length > 0) {
//         // Direct download if files are ready
//         window.location.href = `${API_URL}/file?path=${encodeURIComponent(data.files[0])}`;
//       }
//     } catch (err) {
//       setError('Failed to download media: ' + err.message);
//       setDownloadProgress(prev => ({ ...prev, [id]: 0 }));
//     }
//   };

//   // Directly download a file that already exists on the backend downloads folder
//   const downloadBackendFile = (filename) => {
//     if (!filename) return;
//     // filename should be a relative filename (no path traversal)
//     window.location.href = `${API_URL}/file?path=${encodeURIComponent(filename)}`;
//   };
  
//   // Preview video/image before download
  
//   const handlePreview = async (mediaUrl) => {
//     try {
//       const response = await fetch(`${API_URL}${mediaUrl}`);
//       const blob = await response.blob();
//       if (previewUrl) {
//         URL.revokeObjectURL(previewUrl);
//       }
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     } catch (err) {
//       setError('Failed to preview media: ' + err.message);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setMediaInfo(null);

//     try {
//       const response = await fetch(`${API_URL}/download`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           url,
//           quality: selectedQuality
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || 'Something went wrong');
//       }

//       // If backend returns filenames (yt-dlp), present links to download served files
//       if (data && data.files && Array.isArray(data.files) && data.files.length > 0) {
//         setMediaInfo({ type: 'download', files: data.files });
//       } else {
//         // fallback: keep any mediaInfo returned by scraper-type backend
//         setMediaInfo(data);
//       }
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="app-container">
//       <header>
//         <h1>Instagram Media Downloader</h1>
//         <p>Download photos and videos from Instagram</p>
//       </header>

//       <main>
//         <form onSubmit={handleSubmit}>
//           <div className="input-group">
//             <input
//               type="text"
//               value={url}
//               onChange={(e) => setUrl(e.target.value)}
//               placeholder="Paste Instagram URL here..."
//               required
//             />
//             <button type="submit" disabled={loading}>
//               {loading ? 'Processing...' : 'Process'}
//             </button>
//           </div>
//         </form>

//         {error && <div className="error-message">{error}</div>}
        
//         {mediaInfo && (
//           <div className="success-message">
//             <p>Media found! Click to download:</p>
//             {/* If backend returned raw filenames (files array) render them first */}
//             {mediaInfo.files && Array.isArray(mediaInfo.files) && mediaInfo.files.length > 0 ? (
//               <div className="files-list">
//                 {mediaInfo.files.map((f, idx) => (
//                   <div key={idx} className="file-item">
//                     <span className="file-name">{f}</span>
//                     <button className="download-button" onClick={() => downloadBackendFile(f)}>
//                       Download
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             ) : mediaInfo.type === 'carousel' ? (
//               <div className="carousel-container">
//                 {mediaInfo.media.map((item, index) => (
//                   <div key={index} className="media-item">
//                     {item.type === 'video' ? (
//                       <div className="video-preview">
//                         <img src={item.thumbnail} alt={`Video ${index + 1}`} />
//                         <div className="video-overlay">Video {index + 1}</div>
//                       </div>
//                     ) : (
//                       <img src={item.url} alt={`Image ${index + 1}`} className="image-preview" />
//                     )}
//                     <button
//                       className="download-button"
//                       onClick={() => downloadMedia(item.url, `instagram-${item.type}-${index + 1}.${item.type === 'video' ? 'mp4' : 'jpg'}`)}
//                     >
//                       Download {item.type}
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="single-media">
//                 {mediaInfo.type === 'video' ? (
//                   <div className="video-preview">
//                     <video 
//                       ref={videoRef}
//                       src={mediaInfo.url} 
//                       poster={mediaInfo.thumbnail}
//                       controls
//                       className="video-player"
//                     />
//                   </div>
//                 ) : (
//                   <img src={mediaInfo.url} alt="Media preview" className="image-preview" />
//                 )}
//                 <button
//                   className="download-button"
//                   onClick={() => downloadMedia(mediaInfo.url, `instagram-${mediaInfo.type}.${mediaInfo.type === 'video' ? 'mp4' : 'jpg'}`, 'single')}
//                   disabled={downloadProgress['single'] > 0 && downloadProgress['single'] < 100}
//                 >
//                   {downloadProgress['single'] > 0 && downloadProgress['single'] < 100 
//                     ? `Downloading... ${downloadProgress['single']}%`
//                     : `Download ${mediaInfo.type}`}
//                 </button>
//               </div>
//             )}
//           </div>
//         )}
//       </main>
//     </div>
//   );
// }

// export default App;


import React, { useState, useRef } from 'react';
import './App.css';

function App() {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mediaInfo, setMediaInfo] = useState(null);
  const videoRef = useRef(null);

  const API_URL = 'https://api.banksstatements.com';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMediaInfo(null);

    try {
      const response = await fetch(`${API_URL}/download`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      // backend exact response set
      setMediaInfo(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <header>
        <h1>Instagram Media Downloader</h1>
        <p>Download photos and videos from Instagram</p>
      </header>

      <main>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Paste Instagram URL here..."
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Processing...' : 'Process'}
            </button>
          </div>
        </form>

        {error && <div className="error-message">{error}</div>}

        {mediaInfo && (
          <div className="success-message">
            <h3>{mediaInfo.title}</h3>

            {/* ✅ ORIGINAL VIDEO PREVIEW */}
            <video
              ref={videoRef}
              src={mediaInfo.originalVideoUrl}
              controls
              className="video-player"
            />

            <p style={{ marginTop: '10px' }}>
              {mediaInfo.alreadyDownloaded
                ? 'Video already downloaded on server'
                : 'Video downloaded successfully'}
            </p>
          </div>
        )}
      </main>
    </div>
  );
}

export default App;